import axios from "axios";
import { getAuthenticationHeader } from "../../utils/axiosHeader";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RedirectToRoute } from "../../components/Common/Authentication";

const url = process.env.REACT_APP_API_URL;
export const AddProfessionalServiceUser = createAsyncThunk(
  "attorney/AddProfessionalServiceUser",
  async (args, { rejectWithValue }) => {
    try {
      const resp = await axios.post(`${url}/user/set_common_user`, args, {
        headers: getAuthenticationHeader(),
      });
      return resp.data;
    } catch (err) {
      RedirectToRoute();
      return rejectWithValue(err);
    }
  }
);

export const GetProfessionalServiceListing = createAsyncThunk(
  "attorney/GetProfessionalServiceListing",
  async (args, { rejectWithValue }) => {
    try {
      const { role, status, search, csv } = args;
      const resp = await axios.post(
        `${url}/user/get_user_list_common`,
        {
          role: role,
          status: status,
          search: search,
        },
        {
          headers: getAuthenticationHeader(),
        }
      );
      return { ...resp.data, ...{ csv: csv } };
    } catch (err) {
      RedirectToRoute();
      return rejectWithValue(err);
    }
  }
);

export const UpdateProfessionalServiceDetail = createAsyncThunk(
  "attorney/updateProfessionalServiceDetail",
  async (args, { rejectWithValue }) => {
    try {
      const { values } = args;
      const resp = await axios.post(`${url}/user/common_user_update`, values, {
        headers: getAuthenticationHeader(),
      });
      return resp.data;
    } catch (err) {
      RedirectToRoute();
      return rejectWithValue(err);
    }
  }
);

export const UpdateProfessionalServiceStatus = createAsyncThunk(
  "attorney/UpdateProfessionalServiceStatus",
  async (args, { rejectWithValue }) => {
    try {
      const { userId, isStatus } = args;
      const resp = await axios.post(
        `${url}/user/common_user_update`,
        {
          userId: userId,
          isStatus: isStatus,
        },
        {
          headers: getAuthenticationHeader(),
        }
      );
      return resp.data;
    } catch (err) {
      RedirectToRoute(err);
      return rejectWithValue(err);
    }
  }
);

export const GetSingleProfessionalServiceDetail = createAsyncThunk(
  "attorney/GetSingleProfessionalServiceDetail",
  async (args, { rejectWithValue }) => {
    try {
      const { userId } = args;
      const resp = await axios.post(
        `${url}/user/get_user_info`,
        {
          userId: userId,
        },
        {
          headers: getAuthenticationHeader(),
        }
      );
      return resp.data;
    } catch (err) {
      RedirectToRoute();
      return rejectWithValue(err);
    }
  }
);

const ProfessionalServiceSlice = createSlice({
  name: "attorney",
  initialState: {
    error: false,
    loading: false,
    getAttorneyListing: [],
    getFiduciaryListing: [],
    getCombinedListing: [],
    getSingleAttorneyDetail: null,
  },
  reducers: {
    setProfessionalServicePage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddProfessionalServiceUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddProfessionalServiceUser.fulfilled, (state, action) => {
        state.loading = false;
        state.addAdmin = action?.payload?.data;
      })
      .addCase(AddProfessionalServiceUser.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetProfessionalServiceListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetProfessionalServiceListing.fulfilled, (state, action) => {
        state.loading = false;
        if (!action?.payload?.csv) {
          // Check if this is role 3 (attorney) or role 6 (fiduciary) data
          const requestRole = action.meta.arg.role;
          if (requestRole === 3) {
            state.getAttorneyListing = action?.payload;
          } else if (requestRole === 6) {
            state.getFiduciaryListing = action?.payload;
          }

          // Combine both listings
          const attorneyData = state.getAttorneyListing?.data || [];
          const fiduciaryData = state.getFiduciaryListing?.data || [];
          state.getCombinedListing = {
            ...action?.payload,
            data: [...attorneyData, ...fiduciaryData]
          };
        }
      })
      .addCase(GetProfessionalServiceListing.rejected, (state) => {
        state.loading = false;
      })
      .addCase(GetSingleProfessionalServiceDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetSingleProfessionalServiceDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.getSingleAttorneyDetail = action.payload?.data;
      })
      .addCase(GetSingleProfessionalServiceDetail.rejected, (state) => {
        state.loading = false;
      })
      .addCase(UpdateProfessionalServiceDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateProfessionalServiceDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.getSingleAttorneyDetail = action?.payload?.data;
      })
      .addCase(UpdateProfessionalServiceDetail.rejected, (state) => {
        state.loading = false;
      })
      .addCase(UpdateProfessionalServiceStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateProfessionalServiceStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.getSingleAttorneyDetail = action?.payload?.data;
      })
      .addCase(UpdateProfessionalServiceStatus.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setProfessionalServicePage } = ProfessionalServiceSlice.actions;

export default ProfessionalServiceSlice.reducer;
